import DIApi from './_diApi';

class BudgetChapterGradeAPI extends DIApi {
  controllerName = 'BudgetChapterGrades';
}

export default new BudgetChapterGradeAPI();
